export enum ProjectActionType {
  OPEN = "open",
  EDIT = "edit",
  ADD_CLARIFICATION_REQUEST = "addClarificationRequest",
  NEW_PRODUCT = "newProduct",
  NEW_ROOM = "newRoom",
  NEW_FLOOR = "newFloor",
  EXPORT = "export",
  GAEB_EXPORT = "gaebExport",
  MUSTERHEFT_EXPORT = "musterheftExport",
  ATTACHMENTS = "attachments",
  SHARE = "share",
  DUPLICATE = "duplicate",
  ACTIVATE = "activate",
  MANAGE_TEAM = "manageTeam",
  INVITE_MEMBER = "inviteMember",
  LEAVE_TEAM = "leaveTeam",
  HISTORY = "history",
  DELETE = "delete"
}
